import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=41739688&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=41739688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41739688",
  null
  
)

export default component.exports